var React = require('react');

function ArrowRight2Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M32 16.009c0-.267-.11-.522-.293-.714l-9.899-9.999c-.391-.395-1.024-.394-1.414 0-.391.394-.391 1.034 0 1.428l8.193 8.275H1c-.552 0-1 .452-1 1.01s.448 1.01 1 1.01h27.586l-8.192 8.275c-.391.394-.39 1.034 0 1.428.391.394 1.024.394 1.414 0l9.899-9.999c.187-.189.29-.449.293-.714z","clipRule":"evenodd"}));
}

ArrowRight2Icon.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = ArrowRight2Icon;

ArrowRight2Icon.default = ArrowRight2Icon;
